
import { useVModel } from '@vueuse/core';
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'SurveyInputTextarea',
  props: {

    /**
     * 入力した文字
     */
    modelValue: {
      type: String,
      default: undefined,
    },

    /**
     * 最大文字数
     */
    max: {
      type: Number,
      default: 0,
    },

    /**
     * プレースホルダ
     */
    placeholder: {
      type: String,
      default: '入力してください',
    },
  },
  emits: [
    'update:modelValue',
  ],
  setup(prop) {
    const text = useVModel(prop, 'modelValue');

    // 空白行の高さを計算してくれるように末尾に空白を入れる。
    const internalText = computed(() => text.value + '\u200b');

    return {
      text,
      internalText,
    };
  },
});
